module.exports = __webpack_public_path__ + "img/logo.525079d1.png";